import { useState } from "react";
import { ITransferUserResponsibility } from "./TransferUserResponsibility";

export default function useTransferUserResponsibility(props: ITransferUserResponsibility) {
    const [showDialog, setShowDialog] = useState(false);

    const dialogOpen = showDialog || props.userResponsibilityEntityType !== undefined;

    const onDialogClose = () => {
        setShowDialog(false);
        props.onDialogClose?.();
    };

    return {
        showDialog: dialogOpen,
        setShowDialog,
        onDialogClose,
    };
}
